module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9mYWxsYmFjay1uby1pbWFnZS5zdmciOw=="